import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, DataGrid, Grid, IconButton, IGridColDef, Stack } from 'src/components';
import { useHastalikTanimTaniIptalMutation, useLazyHastalikTanimTaniGetirQuery } from 'src/services/HastalikTanim/HastalikTanimApi';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch, useAppSelector } from 'src/store';
import VwHbsHataliktanimtaniDTO from 'src/models/HastalikTanim/VwHbsHataliktanimtaniDTO';
import HastalikTanimSlice from 'src/store/Slices/GenelTanimlar/HastalikTanimSlice';
import HastalikDialog from './HastalikDialog';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';

interface IHastalikListProps {}
const path = 'pages|hataliktanim';
const HastalikTaniList = (props: IHastalikListProps): JSX.Element => {
  const hastalikTanimActiveRow = useAppSelector((s) => s.hastalikTanim.hastalikTanimActiveRow);
  const hastalikTanimtaniAcitveRow = useAppSelector((s) => s.hastalikTanim.hastalikTanimtaniAcitveRow);
  const dialogParam = useAppSelector((s) => s.hastalikTanim.dialogParam);
  const fetchParam = useAppSelector(s => s.hastalikTanim.fetchParam);

  const [iptal, iptalState] = useHastalikTanimTaniIptalMutation();

  const dispatch = useAppDispatch();
  const confirm = useConfirmation();

  const [query, queryState] = useLazyHastalikTanimTaniGetirQuery({});

  const columns: IGridColDef<VwHbsHataliktanimtaniDTO>[] = [
    {
      field: 'icdaralik',
      headerName: translate(path, 'ICD Aralık'),
      minWidth: 100,
    },
    {
      field: 'icdaciklama',
      headerName: translate(path, 'ICD Açıklama'),
      minWidth: 200,
      flex: 1
    },
    {
      field: 'action',
      headerName: '',
      width: 80,
      renderCell: (params) => {
        return (
          <>
            <IconButton customType="edit" 
                onClick={dialogParamHandler}
            />
            <IconButton 
              customType="delete" 
              onClick={() => {
                iptalHandler(params.row)
              }}
              loading={iptalState.isLoading}
            />
          </>
        );
      }
    }
  ];

  const columheaderHandler = () => {
    return (
      <Stack direction={'row'}>
        <Button customType="add" onClick={dialogParamHandler} />
      </Stack>
    );
  };

  const dialogParamHandler = () => {
    hastaliktanimtaniActiveRowHandler(new VwHbsHataliktanimtaniDTO());
    dispatch(HastalikTanimSlice.actions.setDialogParam(2));
  }

  const hastaliktanimtaniActiveRowHandler = (data: VwHbsHataliktanimtaniDTO) => {
    dispatch(HastalikTanimSlice.actions.setHastalikTanimtaniAcitveRow(data));
  }
  
  const hastalikTanimTaniGetirHandler = () => {
      query({ hastalikId: hastalikTanimActiveRow.id });
  }

  const iptalHandler = (row:VwHbsHataliktanimtaniDTO) => {
    confirm({
        description: translate(path,"Hastalik Tanı Tanımı İptal Edilecektir. Emin Misiniz?"),
        catchOnCancel: true,
        title:"",
        variant:'danger'
    }).then(() => {
        iptal({
            id: row.id
        }).unwrap()
        .then(() => hastalikTanimTaniGetirHandler());  
    })  
  }

  useEffect(() => {
    if (hastalikTanimActiveRow?.id) {
      hastalikTanimTaniGetirHandler()
    }
  }, [hastalikTanimActiveRow]);

  useEffect(() => {
    if(queryState.data?.length > 0 && (!hastalikTanimtaniAcitveRow?.id || queryState.data.filter(f=> f.id === hastalikTanimtaniAcitveRow.id)?.length === 0))
      hastaliktanimtaniActiveRowHandler(queryState.data[0])
    
  }, [queryState.data])

  useEffect(() => {
    if(fetchParam === 2)
    {
        hastalikTanimTaniGetirHandler()
        dispatch(HastalikTanimSlice.actions.setFetchParam(0))
    }
  }, [fetchParam])

  return (
    <>
      <DataGrid
        pinnedColumns={{ right: ['action'] }}
        addHeaderColumn={columheaderHandler()}
        columns={columns}
        rows={queryState.data ? queryState.data : []}
        sx={{ height: '85vh' }}
        loading={queryState.isFetching}
        onRowClick={(e) => {
          dispatch(HastalikTanimSlice.actions.setHastalikTanimtaniAcitveRow(e.row));
        }}
        rowSelectionModel={[hastalikTanimtaniAcitveRow?.id]}
        enableQuickFilter
      />
      {dialogParam === 2 && <HastalikDialog />}
    </>
  );
};

export default HastalikTaniList;
